export const jvClientQueryString = ({ clientId, blkOfBusId, clientName }) => {
    const params = new URLSearchParams();
    if (clientId) params.set("clientId", String(clientId));
    if (blkOfBusId) params.set("blkOfBusId", String(blkOfBusId));
    if (clientName) params.set("clientName", String(clientName));
    return params.toString();
};

export const clientOptionFromSearchParams = (searchParams) => {
    const clientId = searchParams.get("clientId");
    if (!clientId) return null;
    const blkOfBusId = searchParams.get("blkOfBusId");
    const clientName = searchParams.get("clientName");
    return {
        value: clientId,
        label: clientName ? `${clientId}: ${clientName}` : clientId,
        additional: {
            clientid: clientId,
            blkofbusid: blkOfBusId,
            clientname: clientName,
        },
    };
};
